import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Navigation from "../Common/Navigation";
import SideBar from "../Common/SideBar";
import './Dashboard.css'
import Logout from "../Logout";
import GlobalState from "./GlobalState";
import ScrollToTop from "../../shared/utils/ScrollToTop";
import Areas from "../area/Areas";
import CreateArea from "../area/CreateArea";
import EditArea from "../area/EditArea";
import JobCategories from "../job/JobCategories";
import CreateJobCategory from "../job/CreateJobCategory";
import EditJobCategory from "../job/EditJobCategory";
import PlaceCategories from "../place-category/PlaceCategories";
import CreatePlaceCategory from "../place-category/CreatePlaceCategory";
import EditPlaceCategory from "../place-category/EditPlaceCategory";
import AllUsers from "../user/AllUsers";
import UserInfo from './../user/SingleUser/UserInfo';
import AllPersons from "../person/AllPersons";
import PersonInfo from "../person/SinglePerson/PersonInfo";
import CreatePerson from "../person/CreatePerson";
import EditPerson from "../person/EditPerson";
import AllPlaces from "../place/AllPlaces";
import PlaceInfo from "../place/SinglePlace/PlaceInfo";
import CreatePlace from "../place/CreatePlace";
import EditPlace from "../place/EditPlace";
import CreateOrder from "../order/CreateOrder";
import SuccessfullPayment from "../order/SuccessfullPayment";
import Orders from "../order/Orders";
import Comments from "../comment/Comments";
import Viewers from './../viewers/Viewers';
import ProductCategories from "../product-category/ProductCategories";
import CreateProductCategory from "../product-category/CreateProductCategory";
import EditProductCategory from "../product-category/EditProductCategory";
import CreateProduct from "../product/CreateProduct";
import AllProducts from "../product/AllProducts";
import EditProduct from "../product/EditProduct";
import ProductOrders from "../product-order/Orders";

const Dashboard = () => {

    return (
        <React.Fragment>
            <div className="rtl dashboard-layer">
                <GlobalState>
                    <header className="dashboard-header">
                        <Navigation />
                    </header>
                    <div className="container-fluid  py-2 dashboard">
                        <div className="row">
                            <aside className="d-none d-lg-block col-lg-4 col-xl-3">
                                <SideBar />
                            </aside>
                            <section className="col-12 col-lg-8 col-xl-9  ">
                                <div className="bg-white rounded dashboard-body-layer">
                                    <ScrollToTop/>
                                    <Switch>
                                        <Route path='/dashboard' exact 
                                        render={() => 
                                        <h3 style={{textAlign:'center',marginTop:'30vh',fontWeight:'bold'}}>
                                            خوش آمدید
                                        </h3>
                                        }/>
                                        <Route path='/dashboard/areas'  component={Areas} />
                                        <Route path='/dashboard/newarea'  component={CreateArea} />
                                        <Route path='/dashboard/editarea'  component={EditArea} />
                                        <Route path='/dashboard/jobcategories'  component={JobCategories} />
                                        <Route path='/dashboard/newjobcategory'  component={CreateJobCategory} />
                                        <Route path='/dashboard/editjobcategory'  component={EditJobCategory} />
                                        <Route path='/dashboard/placecategories'  component={PlaceCategories} />
                                        <Route path='/dashboard/newplacecategory'  component={CreatePlaceCategory} />
                                        <Route path='/dashboard/editplacecategory'  component={EditPlaceCategory} />
                                        <Route path='/dashboard/productcategories'  component={ProductCategories} />
                                        <Route path='/dashboard/newproductcategory'  component={CreateProductCategory} />
                                        <Route path='/dashboard/editproductcategory'  component={EditProductCategory} />
                                        <Route path='/dashboard/newproduct'  component={CreateProduct} />
                                        <Route path='/dashboard/editproduct'  component={EditProduct} />
                                        <Route path='/dashboard/products'  component={AllProducts} />
                                        <Route path='/dashboard/users'  component={AllUsers} />
                                        <Route path='/dashboard/user'  component={UserInfo} />
                                        <Route path='/dashboard/persons'  component={AllPersons} />
                                        <Route path='/dashboard/person'  component={PersonInfo} />
                                        <Route path='/dashboard/newperson'  component={CreatePerson} />
                                        <Route path='/dashboard/editperson'  component={EditPerson} />
                                        <Route path='/dashboard/places'  component={AllPlaces} />
                                        <Route path='/dashboard/place'  component={PlaceInfo} />
                                        <Route path='/dashboard/newplace'  component={CreatePlace} />
                                        <Route path='/dashboard/editplace'  component={EditPlace} />
                                        <Route path='/dashboard/neworder'  component={CreateOrder} />
                                        <Route path='/dashboard/product-orders' exact component={ProductOrders} />
                                        <Route path='/dashboard/orders' exact component={Orders} />
                                        <Route path='/dashboard/comments' exact component={Comments} />
                                        <Route path='/dashboard/viewers'  component={Viewers} />
                                        <Route path="/dashboard/logout" component={Logout} />
                                        <Route path='/dashboard/paymentsuccessfull' exact component={SuccessfullPayment} />
                                        <Redirect to="/not-found" />
                                    </Switch>
                                </div>
                            </section>
                        </div>
                    </div>
                </GlobalState>
            </div>
        </React.Fragment>

    );
};

export default Dashboard;
